import { useState } from 'react'

import { MobileBottomLayout, PaginationButtons } from 'src/components'
import { LanguageItem } from './language-item.component'
import { UpdateLanguageModal } from '../update-language-form'
import { useRemoveLanguages } from 'src/hooks'
import { ILanguageBaseWithId } from 'src/types'
import { AddLanguageButton } from '../add-language-button'

import { useStyles } from 'src/components/quantity-types/quantity-types-list/styles'
import { DEFAULT_LANGUAGE_CODE } from '../constants'

interface IProps {
  items: ILanguageBaseWithId[]
}

const LanguagesGrid = ({ items }: IProps) => {
  const classes = useStyles()
  const [formValues, setFormValues] = useState<ILanguageBaseWithId | null>(null)
  const { mutateAsync: removeLanguages } = useRemoveLanguages()

  const handleRemove = (id: string) => async () => {
    await removeLanguages([id])
  }

  const handleOpen = (item: ILanguageBaseWithId) => () => {
    if (item.code === DEFAULT_LANGUAGE_CODE) return

    setFormValues(item)
  }

  const handleClose = () => {
    setFormValues(null)
  }

  return (
    <>
      <div className={classes.cardsWrapper}>
        {items?.map((item) => (
          <LanguageItem
            handleDelete={handleRemove(item.id)}
            handleUpdate={handleOpen(item)}
            item={item}
            key={item.id}
          />
        ))}
      </div>
      <AddLanguageButton />
      <UpdateLanguageModal
        handleClose={handleClose}
        open={!!formValues}
        initialValues={formValues}
      />
      <MobileBottomLayout>
        <PaginationButtons buttonsOnly />
      </MobileBottomLayout>
    </>
  )
}

export { LanguagesGrid }
